import { render, staticRenderFns } from "./CustomWizard.vue?vue&type=template&id=3310bd4e&scoped=true"
import script from "./CustomWizard.vue?vue&type=script&lang=js"
export * from "./CustomWizard.vue?vue&type=script&lang=js"
import style0 from "./CustomWizard.vue?vue&type=style&index=0&id=3310bd4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3310bd4e",
  null
  
)

export default component.exports